<template>
  <div>
      <div>
        <h4 v-for="(titulo, index) in titulos" :key="index">
          <template v-if="index == 0">
            <b>{{ titulo }}</b>
          </template>
          <template v-else>
            {{ titulo }}
          </template>
        </h4>    
      </div>
      <apexchart type="line" height="350" :options="chartOptions" :series="series"></apexchart>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
  components: { 
    apexcharts: VueApexCharts,
  },
  props: {
    series: Array,
    labels: Array,
    titulos: Array,
  },
  computed: {
    labelTexts() {
      return this.labels.map((label) => label.text);
    },
    chartOptions() {
      const self = this
      return {
        colors:['#00184D', '#40a474', '#FDDA0D', '#FF5733'],
        chart: {
          height: 350,
          type: "line",          
          events: {
            xAxisLabelClick(event, chartContext, config) {
              const label = self.labels[config.labelIndex]
              self.$emit('selectedLabel', label)
            }
          }
        },
        stroke: {
          width: 3,
        },
        labels: self.labelTexts,
        yaxis: self.yaxis,

        // yaxis: [
        //   {
        //     seriesName: "TX WCHAT",
        //     title: {
        //       text: "TX",
        //     }
        //   },
        //   {
        //     seriesName: "TX WCHAT",
        //     show: false,
        //   },
        //   {
        //     opposite: true,
        //     seriesName: 'AG WCHAT',
        //     title: {
        //       text: "AG",
        //     }
        //   },
        //   {
        //     seriesName: 'AG WCHAT',
        //     show: false,
        //   },
        // ],
      }
    },
    yaxis() {
      const allGroups = this.series.map(serie => serie.group)
      const filteredGroups = [...new Set(allGroups)]
      
      if(!this.series) return []

      const yaxis = []  
      this.series.forEach((serie) => { 
        
      const groupIndex = filteredGroups.findIndex(el => el === serie.group)
      const opposite = !(groupIndex === 0 || groupIndex%2 === 0)
      const show = !yaxis.find(y => y.title.text === serie.group)
        yaxis.push({
          seriesName: serie.name,
          title: {
            text: serie.group,
          },
          show,
          opposite,
        })
      })

      return yaxis 
    },
  }
};
</script>